export const GET_SUBPROJECTS = "GET_SUBPROJECTS";
export const LOADING_SUBPROJECTS = "LOADING_SUBPROJECTS";
export const ERROR_SUBPROJECTS = "ERROR_SUBPROJECTS";
